import { useCallback } from 'react';
import { useAppSelector } from '@/hooks/useAppSelector';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { refreshSessionInit } from '@/store/sessionSlice';

/** Companies loaded once via GET /v1/session/init — no per-mount API call. */
export function useActiveCompanies() {
  const dispatch = useAppDispatch();
  const companies = useAppSelector((s) => s.session.companies);
  const loading = useAppSelector((s) => s.session.loading && !s.session.loaded);
  const loaded = useAppSelector((s) => s.session.loaded);

  const reload = useCallback(async () => {
    await dispatch(refreshSessionInit(undefined));
  }, [dispatch]);

  return { companies, loading: loading || (!loaded && companies.length === 0), reload };
}
